module.exports = __webpack_public_path__ + "img/Marguerite Harper Scott.b90fab71.png";